import { Box, Container, Grid } from "@mui/material";
import { cardUtility } from "../cards/CardUtil";
import ArmyListSearchWidget from "./components/ArmyListSearchWidget";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { getGameSystems } from "../../components/api/APIUtilities";
import { postNotification } from "../../components/utilities/Notifications";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import GameSystemPicker from "../../components/utilities/gamesystempickers/GameSystemPicker";
import { getEnvironmentVariable } from "../../global/environmentVariables";

const SINGLE_GAMETYPE = getEnvironmentVariable("SINGLE_GAMETYPE");
const imageCache = {};

export default function ArmyListSearch(props) {
  const { userSearch, heading } = props;
  const navigate = useNavigate();
  const cardUtil = cardUtility();

  const [loading, setLoading] = useState(
    SINGLE_GAMETYPE !== undefined ? true : false
  );
  const [ready, setReady] = useState(
    SINGLE_GAMETYPE !== undefined ? true : false
  );
  const [gameSystems, setGameSystems] = useState(null);
  const [gameSystem, setGameSystem] = useState(null);

  useEffect(() => {
    const go = async () => {
      var apiGameSystems = await getGameSystems({
        supportsDeckBuilder: true,
      });
      if (!apiGameSystems?.length) {
        postNotification(
          `No ${getEnvironmentVariable(
            "LABEL_GAMESYSTEM"
          )}s setup with a card database`
        );
        navigate("/");
        return;
      }
      setGameSystems(apiGameSystems);
      setLoading(false);
    };
    if (SINGLE_GAMETYPE === undefined) {
      go();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: "100%" }}>
      <Container
        sx={{
          pt: 2,
          pb: 2,
        }}
        maxWidth="lg"
      >
        {!ready && gameSystems && (
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 1,
              boxShadow: 1,
              backgroundColor: "background.secondary",
            }}
          >
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <GameSystemPicker
                  name="gameType"
                  value={gameSystem?.code || ""}
                  handleChange={(e) => {
                    if (e.target.value) {
                      gameSystems.forEach((gs) => {
                        if (gs.code === e.target.value) {
                          setGameSystem(gs);
                          setReady(true);
                          return true;
                        }
                      });
                    }
                  }}
                  gameSystems={gameSystems}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        {ready && (
          <ArmyListSearchWidget
            gameSystem={gameSystem}
            userSearch={userSearch}
            cardUtil={cardUtil}
            imageCache={imageCache}
            heading={
              heading ||
              "List Search"
            }
          />
        )}
      </Container>
      {loading && <ModalLoadingFull />}
    </Box>
  );
}
